import React, {useState} from 'react'
import {FormattedMessage, useIntl} from 'react-intl'
import {
    Box,
    Text,
    Flex,
    Input,
    Button,
    useBreakpointValue,
    useMultiStyleConfig,
    Heading
} from '@chakra-ui/react'
import {useToast} from '@salesforce/retail-react-app/app/hooks/use-toast'
import useSegment from '../../integrations/segment/app/hooks/use-segment'
import {EMAIL_REGEX} from '../../constants'

const Subscribe = (socialIconsContent) => {
    const isDesktop = useBreakpointValue({base: false, lg: true})
    const showToast = useToast()
    const {formatMessage} = useIntl()
    const styles = useMultiStyleConfig('Footer')
    const [email, setEmail] = useState('')
    const [emailError, setEmailError] = useState('')
    const ENTER_KEY = 'Enter'
    const segment = useSegment()

    const validateEmail = (email) => EMAIL_REGEX.test(email)

    const handleEmailSignup = async (e) => {
        e.preventDefault()
        if (!email) {
            setEmailError(
                showToast({
                    title: formatMessage({
                        id: 'newsletter.error.empty_email',
                        defaultMessage: 'Please provide a valid email Id'
                    }),
                    status: 'error',
                    isClosable: true
                })
            )
            return
        }

        if (!validateEmail(email)) {
            setEmailError(
                showToast({
                    title: formatMessage({
                        id: 'newsletter.error.invalid_email',
                        defaultMessage: 'Please provide a valid email Id'
                    }),
                    status: 'error',
                    isClosable: true
                })
            )
            return
        }
        setEmailError('')
        showToast({
            title: formatMessage({
                id: 'email.suscribed.sucess',
                defaultMessage: 'Email Signup successful'
            }),
            status: 'success',
            isClosable: true
        })
        setEmail('')
        segment.sendFooterEmailSubscribe(email)
    }

    return (
        <Box
            pb="4"
            className="news-letter-subscription"
            display={{base: 'block', sm: 'flex', md: 'block'}}
            width={{base: '100%', md: '304px'}}
        >
            <Flex
                direction={'column'}
                width={{base: '100%', sm: '50%', md: '100%'}}
                pr={{base: '0', sm: '3', md: '0'}}
            >
                <Heading as="h3" {...styles.newsLetterHeading}>
                    <FormattedMessage
                        defaultMessage="Join Our Mailing List"
                        id="footer.newsletter.join_email"
                    />
                </Heading>
                <Text fontSize="16px" mb="3">
                    <FormattedMessage
                        defaultMessage="Receive 10% off your first order when you sign up for emails today."
                        id="footer.newsletter.email_offer"
                    />
                </Text>
            </Flex>
            <Flex
                direction={'column'}
                width={{base: '100%', sm: '50%', md: '100%'}}
                pl={{base: '0', sm: '3', md: '0'}}
            >
                <Text fontSize="16px" mb="1" fontWeight={'800'}>
                    <FormattedMessage defaultMessage="Email Address" id="footer.newsletter.email" />
                </Text>
                <Flex as="form" {...styles.newsLetterEmailContainer} overflow="unset">
                    <Input
                        placeholder={formatMessage({
                            id: 'newsletter.field.placeholder.enter_email',
                            defaultMessage: 'Email Address'
                        })}
                        type="email"
                        value={email}
                        onChange={(e) => {
                            setEmail(e.target.value)
                            setEmailError('')
                        }}
                        onKeyDown={(e) => e.key === ENTER_KEY && handleEmailSignup(e)}
                        aria-label="Email Address"
                        {...styles.newsLetterEmailInput}
                    />
                    <Button
                        {...styles.newsLetterSubmitBtn}
                        onClick={(e) => {
                            handleEmailSignup(e)
                        }}
                        aria-label="subscribed sucessfully"
                        textTransform={'capitalize'}
                    >
                        <FormattedMessage
                            defaultMessage="Subscribe"
                            id="footer.newsletter.email_subscribe_text"
                        />
                    </Button>
                </Flex>
                {emailError && (
                    <Text fontSize="sm" mt="1">
                        {emailError}
                    </Text>
                )}
                <Flex
                    className={'footer-social-icons'}
                    justifyContent={isDesktop ? 'start' : 'center'}
                    {...styles.footerSocialIcons}
                >
                    <Box
                        dangerouslySetInnerHTML={{__html: socialIconsContent.socialIconsContent}}
                    />
                </Flex>
            </Flex>
        </Box>
    )
}

export default Subscribe
